import { Link } from '@tanstack/react-router';

const Hero = () => {
  return (
    <div className="w-full pt-8 md:pt-16">
      <div className="flex flex-col lg:flex-row">
        <div className="w-full lg:w-2xl mx-auto px-5 lg:px-8 mb-6 md:mb-12 flex flex-col justify-center text-center md:text-start">
          <h1 className="text-2xl md:text-5xl text-primary font-bold mb-2 md:mb-6">
            Transforming property & resident management
          </h1>
          <p className="text-base md:text-2xl text-secondary mb-4 md:mb-8">
            We simplify property ownership, streamline payments, and bring
            transparency to community living.
          </p>

          <div className="flex flex-col md:flex-row items-center gap-3 md:gap-7">
            <Link to="/sign-in" className="text-sm md:text-lg text-white font-bold bg-[#5761EB] px-3 md:px-6 py-2 md:py-3 rounded-lg">
              Get Started Free
            </Link>
          </div>
        </div>
        <div>
          <div className="">
            <img
              src="/assets/images/about/about-hero.png"
              alt="sobar house"
              className="w-full"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
